export default __webpack_public_path__ + "static/media/taste-rate.0fb92b1f.svg";